import { HeaderNotification, Notification, NotificationCategories } from '@core/domain/model/notifications/notification.model';
import { NotificationCounters } from '@core/domain/model/notifications/notification-counter.model';

export type NotificationsState = {
  error: string | null;
  notifications: Notification[];
  counters: NotificationCounters;
  currentCategory: NotificationCategories;
};

export const notificationsInitialState: NotificationsState = {
  error: null,
  notifications: [],
  counters: {
    unread: 0,
    [NotificationCategories.ALL]: 0,
    [NotificationCategories.ARCHIVED]: 0,
    [NotificationCategories.URGENT]: 0,
    [NotificationCategories.ALERT]: 0,
    [HeaderNotification.INVOICES]: 0,
    [HeaderNotification.PROCEDURES]: 0,
  },
  currentCategory: NotificationCategories.ALL,
};
